import { useMutation, useQueryClient } from "@tanstack/react-query"
import axios from "axios"
import { z } from "zod"
import { DataResponse, GetQRByIdSchema, QRResponseDataSchema } from "schema"

type Response = DataResponse<z.infer<typeof QRResponseDataSchema>>

export function useDeleteQRMutation() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async ({ id }: z.input<typeof GetQRByIdSchema>) => {
      await axios.delete<Response>(`/integrations/qr/${id}`)
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["qr"] })
    },
  })
}
